const Cfg    = require("../config");

const Utill  = require("../utillity/utill");
const Rwd    = require("../utillity/responsive");

const _t     = require("./mousewheel");
const ScrSec = require('../animation/section_scroll');

module.exports.Bind = function(e) {
	// canvas 制御開始
	// canvas対応&スマホ以外
	if ( Utill.CanCanvas() && !Rwd.IsMobile() ) {
		_t.GetDirection(e);
	}
};


module.exports.GetDirection = function(e) {
	if( !Utill.IsPage('home') ) return;
	e.preventDefault();
	var delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
	if (delta < 0){
		ScrSec.ChangeSec(1);
	} else {
		ScrSec.ChangeSec(-1);
	}
};


// WEBPACK FOOTER //
// ./html/_src/js_wb/events/mousewheel.js